define('views/modules/questionnaire/questions/list/options/option-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // custom
    'services/layout',
    // services
    'services/i18n',
    // views
    'views/parts/form/textbox',
    // templates
    'text!templates/modules/questionnaire/questions/list/options/option-list-item.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // custom
    LayoutState,
    // src
    i18n,
    // views
    VTextBox,
    // templates
    TOptionListItem
) {

    var VOptionListItem = Backbone.View.extend({
        template: TOptionListItem,

        events: {
            "click .remove-option-button": "onRemoveOption"
        },

        regions: {
            option: ".option-input"
        },

        initialize: function(opt) {
            this.options = _.extend({}, opt);

            this.view = {
                option: new VTextBox({ label: 'Option', attribute: 'text', labelposition: 'outer', model: this.model })
            };

            this.listenTo(this.model, "remove", this.remove);
        },
        render: function() {

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.option, zone.$option);

            return this;
        },

        onRemoveOption: function(e) {
            this.model.destroy({ sync: false });
        },

    });

    return VOptionListItem;

});

